import api, { studentApi, panelApi } from "./api";

const applicationStatusService = {
  // student
  myApplications: () => studentApi.get("/students/me/applications").then((r) => r.data),
  myApplicationDetail: (id) => studentApi.get(`/students/me/applications/${id}`).then((r) => r.data),

  // panel
  myRounds: () => panelApi.get("/panel/rounds").then((r) => r.data),
  roundStudents: (roundId) => panelApi.get(`/panel/rounds/${roundId}/students`).then((r) => r.data),
    panelStudentDetail: (roundId, studentId) =>
    panelApi
      .get(`/panel/rounds/${roundId}/students/${studentId}`)
      .then((r) => r.data),
  submitFeedback: (roundId, studentId, payload) =>
    panelApi.post(`/panel/rounds/${roundId}/students/${studentId}/feedback`, payload).then((r) => r.data),

  // admin
  campusFunnel: () => api.get("/campus/funnel").then((r) => r.data),
};

export default applicationStatusService;
